import * as A from "fp-ts/Array";
import { MonoidAll, MonoidAny } from "fp-ts/boolean";
import * as E from "fp-ts/Either";
import { identity, pipe } from "fp-ts/function";
import { concatAll } from "fp-ts/Monoid";
import * as O from "fp-ts/Option";
import * as S from "fp-ts/Semigroup";
const firstRight = (candidate, defaultT, resolvers) => {
  const firstRightSemi = E.getSemigroup(S.first());
  const concatFirstRightSemi = S.concatAll(firstRightSemi)(E.left(defaultT));
  return pipe(
    concatFirstRightSemi(
      pipe(
        resolvers,
        A.map(
          (r) => pipe(
            candidate,
            E.fromPredicate(r[0], () => defaultT),
            E.map(r[1])
          )
        )
      )
    ),
    E.fold(identity, identity)
  );
};
const equals = (E2) => (lhs) => (rhs) => E2.equals(lhs, rhs);
const concatApply = (m) => (fns) => (data) => pipe(fns, A.ap(A.of(data)), concatAll(m));
const and = concatApply(MonoidAll);
const or = concatApply(MonoidAny);
const tap = (f) => (data) => {
  f(data);
  return data;
};
const logWithTag = (tag, processor = identity) => (data) => console.log(tag, processor(data));
const stringifyWithTag = (tag) => (data) => console.log(tag, JSON.stringify(data, null, 2));
const log = (tag, processor = identity) => tap(logWithTag(tag, processor));
const deepLog = (tag) => tap(stringifyWithTag(tag));
const getMatches = (regex) => (str) => pipe(regex.exec(str), O.fromNullable);
const stringifyWithReplace = (replacer, space = 2) => (a) => E.tryCatch(() => {
  const s = JSON.stringify(a, replacer, space);
  if (typeof s !== "string") {
    throw new Error("Converting unsupported structure to JSON");
  }
  return s;
}, identity);
export {
  and,
  deepLog,
  equals,
  firstRight,
  getMatches,
  log,
  or,
  stringifyWithReplace,
  tap
};
//# sourceMappingURL=fp-utils.js.map
